import { MarketingWinsRequestParams } from './request';

export interface MarketingEgressWinRequestParams {
  limit?: number;
  skip?: number;
}

export function egressMarketingWinRequestParams(params?: MarketingWinsRequestParams): MarketingEgressWinRequestParams {
  return {
    limit: params?.limit,
    skip: params?.skip,
  };
}
